import script from "./SlotDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlotDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SlotDialog.vue?vue&type=style&index=0&id=a42bf068&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a42bf068"]])

export default __exports__